//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import linkaddress from '@/components/linkaddress';
export default {
  name: 'AreaBox',
  components: {
    linkaddress: linkaddress
  },
  props: {
    areaInit: {
      type: Object,
      default: function _default() {}
    },
    areaDataIndex: {
      type: Number,
      default: null
    },
    link: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: -1
    },
    parentWidth: {
      type: Number,
      default: 0
    },
    parentHeight: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      areaTitle: '',
      url: '',
      // box操作初始点
      move: {
        // 拖动
        startX: 0,
        starY: 0,
        // 形变
        start1X: 0,
        start1Y: 0
      },
      editBoxShow: false,
      itemIndex: ''
    };
  },
  computed: {
    isSet: function isSet() {
      return !!this.link;
    }
  },
  watch: {
    title: function title(val) {
      this.areaTitle = val;
    },
    link: function link(val) {
      this.url = val;
    }
  },
  mounted: function mounted() {
    this.url = this.link;
  },
  methods: {
    getLink: function getLink() {
      // 打开添加链接的模态框
      this.$refs.linkaddres.dialogVisible = true;
    },
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？', '提示', {
        type: 'warning'
      }).then(function (_) {
        done();
      }).catch(function (_) {});
    },
    // 删除
    del: function del() {
      this.$emit('delAreaBox', this.areaDataIndex);
    },
    // 结束拖动/变形
    mouseUp: function mouseUp() {
      document.onmousemove = null;
    },
    // 形变开始
    shapeDown: function shapeDown(e) {
      var _this = this;
      e.preventDefault();
      this.star1X = e.clientX;
      this.star1Y = e.clientY;
      // 获取左部和底部的偏移量

      if (!document.onmousemove) {
        var initX = this.areaInit.areaWidth;
        var initY = this.areaInit.areaHeight;
        document.onmousemove = function (ev) {
          _this.areaInit.areaWidth = initX + ev.clientX - _this.star1X;
          if (_this.areaInit.areaWidth < 50) {
            _this.areaInit.areaWidth = 50;
          }
          _this.areaInit.areaHeight = initY + ev.clientY - _this.star1Y;
          if (_this.areaInit.areaHeight < 50) {
            _this.areaInit.areaHeight = 50;
          }
        };
      }
    },
    linkUrl: function linkUrl(e) {
      // 将链接地址存储到对应的数据项中
      this.$emit('addURL', this.areaDataIndex, e);
    },
    // 开始拖动限制范围
    mouseDownLint: function mouseDownLint(e) {
      var _this2 = this;
      e.preventDefault();
      this.starX = e.clientX;
      this.starY = e.clientY;
      var childrenDiv = e.target || e;
      //获取子元素的宽高
      var childrenWidth = childrenDiv.getBoundingClientRect().width;
      var childrenHight = childrenDiv.getBoundingClientRect().height;
      if (!document.onmousemove) {
        var initX = this.areaInit.starX;
        var initY = this.areaInit.starY;
        document.onmousemove = function (ev) {
          // 移动位置
          var nLeft = initX + ev.clientX - _this2.starX;
          var nTop = initY + ev.clientY - _this2.starY;
          nLeft = nLeft <= 0 ? 0 : nLeft; //判断左边是否越界
          nTop = nTop <= 0 ? 0 : nTop; //判断上边是否越界
          var nRight = nLeft + childrenWidth;
          var nBottom = nTop + childrenHight;
          // 判断右边是否越界
          if (nRight >= _this2.parentWidth) {
            nLeft = _this2.parentWidth - childrenWidth;
          }
          // 判断下边是否越界
          if (nBottom >= _this2.parentHeight) {
            nTop = _this2.parentHeight - childrenHight;
          }
          _this2.areaInit.starX = nLeft;
          _this2.areaInit.starY = nTop;
        };
      }
    },
    // 开始拖动不限制范围
    mouseDown: function mouseDown(e) {
      var _this3 = this;
      e.preventDefault();
      this.starX = e.clientX;
      this.starY = e.clientY;
      if (!document.onmousemove) {
        var initX = this.areaInit.starX;
        var initY = this.areaInit.starY;
        document.onmousemove = function (ev) {
          _this3.areaInit.starX = initX + ev.clientX - _this3.starX;
          _this3.areaInit.starY = initY + ev.clientY - _this3.starY;
        };
      }
    }
  }
};